/* eslint-disable jsx-a11y/label-has-for */
import ReactInputMask from "react-input-mask";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../../constants/Contract";
import NavigationButtons from "../../../../SharedComponents/NavigationButtons";

function StepTwo({
  state,
  onBlur,
  onKeyDown,
  handleChange,
  handleIndividualLifeChange,
  handleIndividualAnnuityChange,
  handleIndividualDisabilityChange,
  handleLongTermCareChange,
  handleFullTimeRoleChange,
  handleTrainingChange,
  onlyNumeric,
  pasteCommaDelimited,
  hasNYRegs,
  addClick,
  backClick,
  handleNext,
  contracttype,
}) {
  const renderLabel = () => {
    return state.review_edit
      ? contracttype === CONTRACT_TYPE_DESCRIPTIONS.MMLIS && state.sales === "Y"
        ? "SAVE"
        : "Next"
      : "ADD";
  };

  return (
    <>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_break_intro_text">
            Did this position involve the direct solicitation of and
            compensation for:
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_ind_life_label">
            Individual Life Insurance
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5px" }}>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="individual_life_yes"
            name="individual_life"
            className="custom-control-input"
            checked={state.individual_life === "Y"}
            value="Y"
            onChange={handleIndividualLifeChange}
          />
          <label
            htmlFor="individual_life_yes"
            className="custom-control-label"
            id="label_individual_life_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio radio-no">
          <input
            type="radio"
            id="individual_life_no"
            name="individual_life"
            className="custom-control-input"
            checked={state.individual_life === "N"}
            value="N"
            onChange={handleIndividualLifeChange}
          />
          <label
            htmlFor="individual_life_no"
            className="custom-control-label"
            id="label_individual_life_no"
          >
            No
          </label>
        </div>
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_ind_annuity_label">
            Individual Annuity
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5px" }}>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="individual_annuity_yes"
            name="individual_annuity"
            className="custom-control-input"
            checked={state.individual_annuity === "Y"}
            value="Y"
            onChange={handleIndividualAnnuityChange}
          />
          <label
            htmlFor="individual_annuity_yes"
            className="custom-control-label"
            id="label_individual_annuity_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio radio-no">
          <input
            type="radio"
            id="individual_annuity_no"
            name="individual_annuity"
            className="custom-control-input"
            checked={state.individual_annuity === "N"}
            value="N"
            onChange={handleIndividualAnnuityChange}
          />
          <label
            htmlFor="individual_annuity_no"
            className="custom-control-label"
            id="label_individual_annuity_no"
          >
            No
          </label>
        </div>
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_ind_disability_label">
            Individual Disability Income
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5px" }}>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="individual_disability_yes"
            name="individual_disability"
            className="custom-control-input"
            checked={state.individual_disability === "Y"}
            value="Y"
            onChange={handleIndividualDisabilityChange}
          />
          <label
            htmlFor="individual_disability_yes"
            className="custom-control-label"
            id="label_individual_disability_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio radio-no">
          <input
            type="radio"
            id="individual_disability_no"
            name="individual_disability"
            className="custom-control-input"
            checked={state.individual_disability === "N"}
            value="N"
            onChange={handleIndividualDisabilityChange}
          />
          <label
            htmlFor="individual_disability_no"
            className="custom-control-label"
            id="label_individual_disability_no"
          >
            No
          </label>
        </div>
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_ind_ltc_label">
            Individual Long Term Care Insurance
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5px" }}>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="individual_longterm_yes"
            name="individual_longterm"
            className="custom-control-input"
            checked={state.individual_longterm === "Y"}
            value="Y"
            onChange={handleLongTermCareChange}
          />
          <label
            htmlFor="individual_longterm_yes"
            className="custom-control-label"
            id="label_individual_longterm_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio radio-no">
          <input
            type="radio"
            id="individual_longterm_no"
            name="individual_longterm"
            className="custom-control-input"
            checked={state.individual_longterm === "N"}
            value="N"
            onChange={handleLongTermCareChange}
          />
          <label
            htmlFor="individual_longterm_no"
            className="custom-control-label"
            id="label_individual_longterm_no"
          >
            No
          </label>
        </div>
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_full_time_role_label">
            Was this a full-time or part-time role?
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5px" }}>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="full_time_role"
            name="full_time_role"
            className="custom-control-input"
            checked={state.full_time_role === "Y"}
            value="Y"
            onChange={handleFullTimeRoleChange}
          />
          <label
            htmlFor="full_time_role"
            className="custom-control-label"
            id="label_full_time_role"
          >
            Full-Time
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio radio-no">
          <input
            type="radio"
            id="part_time_role"
            name="part_time_role"
            className="custom-control-input"
            checked={state.full_time_role === "N"}
            value="N"
            onChange={handleFullTimeRoleChange}
          />
          <label
            htmlFor="part_time_role"
            className="custom-control-label"
            id="label_part_time_role"
          >
            Part-Time
          </label>
        </div>
      </div>
      <div className="full-part-time-help-text">
        <strong>Full-Time:</strong> Typically more than 35 hours per week on a
        regular schedule devoted to selling or soliciting LADL business.
        <br />
        <strong>Part-Time:</strong> Less than 35 hours per week on a regular
        schedule devoted to selling or soliciting LADL business.
      </div>
      <div className="row" style={{ marginTop: "15px" }}>
        <div className="col-md-12">
          <span id="emp_hist_training_or_subsidy_label">
            Did you receive a training or financing subsidy while employed by
            this company?
            <strong>*</strong>
          </span>
        </div>
      </div>
      <div className="row" style={{ marginTop: "5px" }}>
        <div className="col-md-3 custom-control custom-radio">
          <input
            type="radio"
            id="training_yes"
            name="training"
            className="custom-control-input"
            checked={state.training === "Y"}
            value="Y"
            onChange={handleTrainingChange}
          />
          <label
            htmlFor="training_yes"
            className="custom-control-label"
            id="label_training_yes"
          >
            Yes
          </label>
        </div>
        <div className="col-md-3 custom-control custom-radio radio-no">
          <input
            type="radio"
            id="training_no"
            name="training"
            className="custom-control-input"
            checked={state.training === "N"}
            value="N"
            onChange={handleTrainingChange}
          />
          <label
            htmlFor="training_no"
            className="custom-control-label"
            id="label_training_no"
          >
            No
          </label>
        </div>
      </div>
      {state.show_training_info && (
        <>
          <div className="row" style={{ marginTop: "15px" }}>
            <div className="col-md-12">
              <span id="emp_hist_if_yes_training_label">
                If yes, provide training period:
                <strong>*</strong>
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6" style={{ marginTop: "10px" }}>
              <label
                htmlFor="training_start_date"
                id="emp_hist_training_start_date_label"
              >
                <strong>Start Date</strong>
              </label>
              <ReactInputMask
                id="training_start_date"
                mask="99/99/9999"
                maskChar="_"
                className={
                  state?.training_start_date_error
                    ? "form-control is-invalid"
                    : "form-control"
                }
                placeholder="MM/DD/YYYY"
                value={state.training_start_date}
                onBlur={onBlur}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                autoComplete="off"
              />
              {state?.training_start_date_error && (
                <div
                  id="training_start_date_error"
                  className="invalid-feedback"
                >
                  {state?.training_start_date_error_text}
                </div>
              )}
            </div>
            <div className="col-md-6" style={{ marginTop: "10px" }}>
              <label
                htmlFor="training_end_date"
                id="emp_hist_training_end_date_label"
              >
                <strong>End Date</strong>
              </label>
              <ReactInputMask
                id="training_end_date"
                mask="99/99/9999"
                maskChar="_"
                className={
                  state?.training_end_date_error
                    ? "form-control is-invalid"
                    : "form-control"
                }
                placeholder="MM/DD/YYYY"
                value={state.training_end_date}
                onBlur={onBlur}
                onChange={handleChange}
                onKeyDown={onKeyDown}
                autoComplete="off"
              />
              {state?.training_end_date_error && (
                <div id="training_end_date_error" className="invalid-feedback">
                  {state?.training_end_date_error_text}
                </div>
              )}
            </div>
          </div>

          {hasNYRegs === false && (
            <div className="row" style={{ marginTop: "10px" }}>
              <div className="col-md-12">
                <span id="emp_hist_subsidy_label">
                  Total subsidy received from this employer:*
                </span>
                <div
                  className={`input-group ${
                    state.subsidy_error ? "is-invalid" : ""
                  }`}
                  id="subsidy_input"
                >
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text input-group-text-pad-right"
                      id="subsidy_input_$"
                    >
                      $
                    </span>
                  </div>
                  <input
                    type="text"
                    id="subsidy"
                    className="form-control input-pad-left"
                    spellCheck="false"
                    maxLength={11}
                    value={state.subsidy}
                    onBlur={onBlur}
                    onChange={handleChange}
                    onKeyDown={onKeyDown}
                    onKeyPress={onlyNumeric}
                    onPaste={pasteCommaDelimited}
                    autoComplete="off"
                  />
                </div>
                {state.subsidy_error && (
                  <div id="subsidy_error" className="invalid-feedback">
                    Please enter Total subsidy received from this employer
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
      {/* ADD BUTTON PANEL START */}
      {state.show_add_button && (
        <NavigationButtons
          nxtbtnid={"empHistNextBtn"}
          nextBtnText={renderLabel()}
          onNext={state.review_edit ? handleNext : addClick}
          bckbtnid={"empHistBackBtn"}
          backBtnText="Back"
          onBack={backClick}
          isDisabled={state.is_add_disabled || state.showSaveLoader}
          isLoading={state.showSaveLoader}
        ></NavigationButtons>
      )}
      {/* ADD BUTTON PANEL END */}
    </>
  );
}

export default StepTwo;
